import React from "react";
import { RouterProvider } from "react-router-dom";
import { AccessibilityProvider } from "./components/AccessibilityProvider";
import { AuthProvider } from "./contexts/AuthProvider";
import { router } from "./router/router";
import "./styles/animations.css";
import "./styles/main.css";
import { brandingConfig } from "./config/branding";
import { useEffect } from "react";
import { FloatingContactButton } from "./components/FloatingContactButton";

export default function App() {
  useEffect(() => {
    const root = document.documentElement;
    Object.entries(brandingConfig.colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });

    if (brandingConfig.font) {
      // Inject @font-face dynamically based on branding config
      const { fontFamily, fontWeight, fontStyle, fontDisplay, fontSrc } =
        brandingConfig.font;
      if (fontSrc) {
        const fontFace = `
          @font-face {
            font-family: "${fontFamily
              .split(",")[0]
              .replace(/['"]/g, "")
              .trim()}";
            font-style: ${fontStyle || "normal"};
            font-weight: ${fontWeight || "400"};
            font-display: ${fontDisplay || "swap"};
            src: url('${fontSrc}') format('woff2');
          }
        `;
        const style = document.createElement("style");
        style.appendChild(document.createTextNode(fontFace));
        document.head.appendChild(style);
      }
      root.style.setProperty("--font-family", fontFamily);
    }
  }, []);
  return (
    <AuthProvider>
      <AccessibilityProvider>
        <RouterProvider router={router} />
        <FloatingContactButton />
      </AccessibilityProvider>
    </AuthProvider>
  );
}
